import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-service">
      <div className="container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: January 10, 2026</p>

        <section className="section">
          <h2>1. Introduction</h2>
          <p>Welcome to Falphin ("we," "our," or "us"). These Terms of Service ("Terms") govern your use of our music distribution platform and services.</p>
        </section>

        <section className="section">
          <h2>2. Account and Fees</h2>
          <ul>
            <li><strong>One-Time Fee:</strong> Account creation requires a one-time fee. No recurring or hidden charges.</li>
            <li><strong>No Subscription:</strong> We don't charge annual or monthly subscription fees.</li>
            <li><strong>Revenue Share:</strong> We earn only when you do, through a percentage of your earnings.</li>
          </ul>
        </section>

        <section className="section">
          <h2>3. Your Content</h2>
          <ul>
            <li><strong>Ownership:</strong> You retain full ownership of all content you upload.</li>
            <li><strong>License:</strong> You grant us a non-exclusive license to distribute your content to our partner platforms.</li>
            <li><strong>Review Process:</strong> All content undergoes manual review before distribution.</li>
            <li><strong>Rejection Rights:</strong> We may reject or remove content that violates our guidelines or applicable laws.</li>
          </ul>
        </section>

        <section className="section">
          <h2>4. Your Responsibilities</h2>
          <ul>
            <li>You own or have all necessary rights to the content you upload.</li>
            <li>Your content doesn't infringe on any third-party rights.</li>
            <li>You won't engage in fraudulent streaming or artificial manipulation of play counts.</li>
            <li>You'll provide accurate payment and tax information.</li>
          </ul>
        </section>

        <section className="section">
          <h2>5. Prohibited Content</h2>
          <p>You may not upload content that:</p>
          <ul>
            <li>Contains hate speech, violence, or illegal material</li>
            <li>Infringes on intellectual property rights</li>
            <li>Contains viruses or malicious code</li>
            <li>Is designed to manipulate our systems or metrics</li>
          </ul>
        </section>

        <section className="section">
          <h2>6. Payments and Payouts</h2>
          <ul>
            <li><strong>Payout Threshold:</strong> Minimum earnings of $50 are required before withdrawal.</li>
            <li><strong>Payment Schedule:</strong> Monthly payments, processed within 30 days of month-end.</li>
            <li><strong>Fees:</strong> We deduct our revenue share before calculating your earnings.</li>
          </ul>
        </section>

        <section className="section">
          <h2>7. Account Termination</h2>
          <p>We may suspend or terminate accounts that violate these Terms. Upon termination:</p>
          <ul>
            <li>Your access to our services will end</li>
            <li>You'll receive any outstanding earnings (above the minimum threshold)</li>
            <li>Your music will be removed from our distribution network</li>
            <li>You maintain ownership of all your content</li>
          </ul>
        </section>

        <section className="section">
          <h2>8. Limitation of Liability</h2>
          <p>Falphin is not liable for:</p>
          <ul>
            <li>Service interruptions or technical issues</li>
            <li>Content removal by third-party platforms</li>
            <li>Changes in platform policies or algorithms</li>
            <li>Indirect, incidental, or consequential damages</li>
          </ul>
        </section>

        <section className="section">
          <h2>9. Changes to Terms</h2>
          <p>We may update these Terms. We'll notify you of significant changes. Continued use means acceptance of new terms.</p>
        </section>

        <section className="section">
          <h2>10. Contact</h2>
          <p>Questions? Contact us at <a href="mailto:legal@falphin.com">legal@falphin.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
